import { render } from "./successPaye.vue?vue&type=template&id=6822ba7e&scoped=true"
import script from "./successPaye.vue?vue&type=script&lang=js"
export * from "./successPaye.vue?vue&type=script&lang=js"

import "./successPaye.vue?vue&type=style&index=0&id=6822ba7e&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6822ba7e"]])

export default __exports__